import { FlowCreateEncounterSummaryBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const CreateEncounterSummaryBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CreateEncounterSummary),
  returnType: returnTypeSchema(ProducedType.EncounterSummary),
  config: FlowCreateEncounterSummaryBlockConfigSchema,
});
export type CreateEncounterSummaryBlock = z.infer<typeof CreateEncounterSummaryBlockSchema>;
